import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import i18next from 'i18next';
import './config/i18config'
import './index.scss';
import { AppRouter } from './appRouter';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <I18nextProvider i18n={ i18next }>
            <RouterProvider router={ AppRouter } />
        </I18nextProvider>
    </React.StrictMode>
);
